import { render, staticRenderFns } from "./dashboard-comp.vue?vue&type=template&id=36be17c4&scoped=true&"
import script from "./dashboard-comp.vue?vue&type=script&lang=ts&"
export * from "./dashboard-comp.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-comp.vue?vue&type=style&index=0&id=36be17c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be17c4",
  null
  
)

export default component.exports